import Paginator from "../../../components/Paginator";
import {useDispatch, useSelector} from "react-redux";
import {tryLoadUsers} from "../../../redux/slices/manageUserSlice";

export default function UsersPaginator() {
  const selectedTab = useSelector((state) => state.manageUser.selectedTab);

  const {page, totalPages} = useSelector((state) => state.manageUser[selectedTab].meta)

  const {
    loading = false, init = false, error

  } = useSelector((state) => state.manageUser[selectedTab].pageData[page]) ?? {};


  const dispatch = useDispatch();

  const onPagesClick = (page) => {
    dispatch(tryLoadUsers({page}));
  };


  return (
    <>
      {!error &&
      <Paginator currentPage={page} totalPages={totalPages} onClick={onPagesClick}
               loading={!init || loading}/>}
    </>
  );
}

